import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const FirstSection = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, 
    threshold: 1, 
  });
  return (
    <section className="f-sec">
      <div className="background">
        <img className="water-f" src="img/water-surface-level-shot-rocks-reefs-sea-sunny-day.jpg" alt="Water Surface" />
        <div className="gradient"></div>
      </div>
      <div className="mob-back"></div>
      <div className="flex">
        <div className="f-left" ref={ref}>
          <div className="no">
            {inView && <CountUp start={0} end={13} duration={2.5} />} 
            <span>ΕΚΑΤΟΜΜΥΡΙΑ ΕΥΡΩ</span>
          </div>
          <div className="no">
            {inView && <CountUp start={0} end={4} duration={2.5} />} 
            <span>ΔΕΣΜΕΥΣΕΙΣ</span>
          </div>
          <div className="no">
            {inView && <CountUp start={0} end={1} duration={2.5} />}
            <span>ΩΚΕΑΝΟΣ</span>
          </div>
        </div>
        <div className="f-right">
          <h2>Στην καρδιά του 9ου Our Ocean Conference</h2>
          <p>Η προστασία του θαλάσσιου περιβάλλοντος είναι ο κορμός των δράσεών μας και για
            αυτό δε θα μπορούσαμε να λείπουμε από τη σημαντικότερη διεθνή περιβαλλοντική
            διοργάνωση. Με ενεργό ρόλο σε συνεδριάσεις και τη διοργάνωση δύο εκδηλώσεων,
            ανακοινώσαμε τις μεγαλύτερες δεσμεύσεις που έγιναν από ιδιωτικό μη κερδοσκοπικό
            φορέα, συνολικού ύψους 13 εκατομμυρίων ευρώ. Για την επόμενη πενταετία, θα
            έχουμε ενεργό δράση και σημαντικές συνεργασίες που θα αλλάξουν το μέλλον των
            θαλάσσιων περιοχών της Ελλάδας, αλλά και της Μεσογείου.</p>
        </div>
      </div>
    </section>

  );
};

export default FirstSection;
